<template>
  <div>
    <div style="display: inline">
      <badge :type="getDeliveryBadgeType()">
        {{ $t(`SHIPMENTS.ESTIMATIONS_STATUS_${estimation.status}`) }}
      </badge>
    </div>
  </div>
</template>

<script>
import {
  STATUS_CANCEL,
  STATUS_PENDING,
  STATUS_APPROVED,
} from "@/constants/shipments";

export default {
  name: "estimation-status-badge-component",

  components: {},

  mixins: [],

  props: ["estimation"],

  data() {
    return {};
  },

  computed: {},

  methods: {
    getDeliveryBadgeType() {
      switch (this.estimation.status) {
        case STATUS_PENDING:
          return "primary";
        case STATUS_APPROVED:
          return "success";
        case STATUS_CANCEL:
          return "danger";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
